// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2492":"951c4605","3911":"20348ca7","4303":"20348ca7","4407":"20348ca7","5877":"951c4605","6516":"54736b58","6533":"5fccd88b","9958":"951c4605"}[chunkId] + ".chunk.css";
};